import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { db } from "../db/firestore";
import { formatTime } from '../Utility/function';
import { stringYMDHMS3 } from '../Utility/dateTime';
import { initialShift } from '../configs'
import { normalSort } from '../Utility/sort';

const initialState = {
    shifts:[], // 
    modal_Shift:false,
    startDate:new Date(),
    endDate:new Date(),
    billDates:[],
    displayShifts:[],
};


export const fetchShift = createAsyncThunk(
  'shift/fetchShift',
  async ({ shopId, billDate, selectedDate }) => {
    let data = [];

    // Split billDate into chunks of 10 elements each
    const chunkSize = 10;
    const billDateChunks = [];
    for (let i = 0; i < billDate.length; i += chunkSize) {
      billDateChunks.push(billDate.slice(i, i + chunkSize));
    }

    // Use Promise.all to make multiple queries
    const promises = billDateChunks.map(async (chunk) => {
      const query = db.collection('shiftHistory')
        .where("shopId", "==", shopId)
        .where('lastShiftDate', 'in', chunk); // วันเปิดกะ 20200307

      try {
        const qsnapshot = await query.get();
        if (qsnapshot.docs.length > 0) {
          qsnapshot.forEach((doc) => {
            const { openTime, closeTime,  ...rest } = { ...initialShift,... doc.data()}
            data.push({ 
              ...rest, 
              openTime:formatTime(openTime), 
              closeTime:formatTime(closeTime), 
              id: doc.id, 

            });
          });
        } else {
          console.log('No items found for chunk:', chunk);
        }
      } catch (err) {
        console.error('Error:', err);
      }
    });

    // Wait for all queries to complete
    await Promise.all(promises);
    return { data, billDate, selectedDate };
  }
);



export const shiftSlice = createSlice({
  name: 'shift',
  initialState,
  reducers: {
    updateStartDate: (state, action) => {
      state.startDate = action.payload
    },
    updateEndDate: (state, action) => {
      state.endDate = action.payload
    },
    clearShift: state => {
      state.shifts = []
      state.startDate = new Date();
      state.endDate = new Date();
      state.billDates = [];
      state.displayShifts = [];
    },
    updateShifts: (state, action) => {
      const { selectedDate } = action.payload
      state.displayShifts = normalSort('closeTime',state.shifts.filter(a=>[selectedDate].includes(a.lastShiftDate)))
  }, 
  },
  extraReducers: builder => {
    builder.addCase(fetchShift.pending, state => {
      state.modal_Shift = true
    })
    builder.addCase(fetchShift.fulfilled, (state, action) => {
      const { data, billDate, selectedDate } = action.payload;
      const today = stringYMDHMS3(new Date());
    
      const isDuplicate = billDate.includes(today);
    
      state.shifts = isDuplicate
        ? [
            ...state.shifts.filter(shift => shift.lastShiftDate !== today),
            ...data,
          ]
        : [...state.shifts, ...data];
    
      state.billDates.push(...billDate.filter(date => date !== today));
    
      state.displayShifts = normalSort(
        'closeTime',
        state.shifts.filter(shift => selectedDate.includes(shift.lastShiftDate))
      );
    
      state.modal_Shift = false;
    });
    builder.addCase(fetchShift.rejected, state => {
        state.modal_Shift = false
    })
  }
})

export const { updateShifts, clearShift, updateStartDate, updateEndDate
} = shiftSlice.actions

export default shiftSlice.reducer